module.exports = __webpack_public_path__ + "cancel-v1-7d0a4e3f.svg";